const { same } = require('../utils');

module.exports = borders => same(borders, 'stroke.width', 0);
